import type { ReactElement } from 'react';

export function CartPrice({
  retail,
  discounted,
}: {
  retail: number;
  discounted?: number;
}): ReactElement {
  const [dollarRetail, centsRetail] = retail.toFixed(2).split('.');

  if (Number.isNaN(retail) || Number.isNaN(discounted)) return <></>;

  if (retail === discounted || discounted === undefined) {
    return (
      <div className="flex flex-col font-secondary">
        <span className="retail inline-flex items-start font-bold text-lg">
          $<span className="text-2xl">{dollarRetail}</span>.{centsRetail}
        </span>
      </div>
    );
  }

  const [dollarDiscounted, centsDiscounted] = discounted.toFixed(2).split('.');

  return (
    <div className="flex flex-col font-secondary">
      <div className="flex gap-2 text-base">
        <span className="sale inline-flex items-start font-bold">
          $<span className="text-2xl">{dollarDiscounted}</span>.
          {centsDiscounted}
        </span>
        <span className="relative inline-flex items-start text-grey-dark dark:text-grey-mid line-through">
          $<span className="text-lg">{dollarRetail}</span>.{centsRetail}
        </span>
      </div>
    </div>
  );
}

export function QuickCartPrice({
  retail,
  discounted,
}: {
  retail: number;
  discounted?: number;
}): ReactElement {
  if (Number.isNaN(retail) || Number.isNaN(discounted)) return <></>;

  if (retail === discounted || discounted === undefined) {
    return (
      <div className="font-secondary tracking-wide">${retail.toFixed(2)}</div>
    );
  }

  return (
    <div className="flex flex-col font-secondary tracking-wide">
      <div className="flex gap-2">
        <span className="sale font-bold">${discounted.toFixed(2)}</span>
        <span className="relative text-grey-dark dark:text-grey-mid line-through">
          ${retail.toFixed(2)}
        </span>
      </div>
    </div>
  );
}
